import { useCallback, useState } from "react";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { exportHeatMapReport } from "../api/heat-map.api";
import type { DashboardFilterPayload } from "../utils/heat-map.utils";
import { downloadBlob } from "../utils/heat-map.utils";

export const useExportHeatMapReport = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const exportReport = useCallback(async (payload: DashboardFilterPayload): Promise<void> => {
    setLoading(true);
    setError(null);

    try {
      const result = await exportHeatMapReport(payload);
      downloadBlob(result.data, result.contentType, result.filename);
    } catch (exportError) {
      const message = getApiErrorMessage(exportError, "Failed to export report");
      setError(message);
      throw exportError;
    } finally {
      setLoading(false);
    }
  }, []);

  return { exportReport, loading, error };
};
